import { Box, IconButton, styled } from "@mui/material";

export const SidebarContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const ActionIconButton = styled(IconButton)`
  padding: ${({ theme }) => theme.spacing(0.25)};
`;
